/* @flow */

import React from "react";
import {FormattedMessage} from 'react-intl';
import ReactDom from 'react-dom';
import Localizable from "lib/intl/localizable";
import {observer} from "mobx-react";

require("photoswipe/dist/photoswipe.css");
require('photoswipe/dist/default-skin/default-skin.css');

@Localizable()
@observer
class PhotoSwipeView extends React.Component {
    node: ?HTMLDivElement;

    componentDidMount() {
        this.node = document.createElement('div');
        document.body.appendChild(this.node);

        ReactDom.render((
            <div ref={this.props.element} className='pswp' tabIndex={-1} role='dialog' aria-hidden='true'>
                <div className='pswp__bg' />
                <div className='pswp__scroll-wrap'>
                    <div className='pswp__container'>
                        <div className='pswp__item' />
                        <div className='pswp__item' />
                        <div className='pswp__item' />
                    </div>
                    <div className='pswp__ui pswp__ui--hidden'>
                        <div className='pswp__top-bar'>
                            <div className='pswp__counter' />

                            <button className='pswp__button pswp__button--close' title={<FormattedMessage id='BUTTON_LABEL_CLOSE' />} />
                            <button className='pswp__button pswp__button--share' title={<FormattedMessage id='BUTTON_LABEL_SHARE' />} />
                            <button className='pswp__button pswp__button--fs' title={<FormattedMessage id='BUTTON_LABEL_FULLSCREEN' />} />
                            <button className='pswp__button pswp__button--zoom' title={<FormattedMessage id='BUTTON_LABEL_ZOOM' />} />
                            <div className='pswp__preloader'>
                                <div className='pswp__preloader__icn'>
                                    <div className='pswp__preloader__cut'>
                                        <div className='pswp__preloader__donut' />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='pswp__share-modal pswp__share-modal--hidden pswp__single-tap'>
                            <div className='pswp__share-tooltip' />
                        </div>
                        <button className='pswp__button pswp__button--arrow--left' title={<FormattedMessage id='BUTTON_LABEL_PREVIOUS' />} />
                        <button className='pswp__button pswp__button--arrow--right' title={<FormattedMessage id='BUTTON_LABEL_NEXT' />} />
                        <div className='pswp__caption'>
                            <div className='pswp__caption__center' />
                        </div>
                    </div>
                </div>
            </div>
        ), this.node);
    }

    componentWillUnmount() {
        if (this.node && this.node.parentNode) {
            this.node.parentNode.removeChild(this.node);
        }

        this.node = null;
    }

    render() {
        return null;
    }
}


export default PhotoSwipeView;
